
import { Component, OnInit } from "@angular/core";
import { Observable, switchMap } from "rxjs";
import { FormGroup } from "@angular/forms";
import {
  DataService,
  CustomDetailComponent,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { RequestPurchaseInfoByProductDocument } from "../../generated-graphql/graphql";


@Component({
    templateUrl: './request-purchase-info.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class ProductRequestPurchaseInfoComponent
  implements CustomDetailComponent, OnInit
{
  // These two properties are provided by Vendure and will vary
  // depending on the particular detail page you are embedding this
  // component into. In this case, it will be a "product" entity.
  entity$: Observable<any>;
  detailForm: FormGroup;

  extraInfo$: Observable<any>;

  constructor(private dataService: DataService) {}

  ngOnInit() {
    this.extraInfo$ = this.entity$.pipe(
      switchMap(entity =>
        this.dataService
          .query(RequestPurchaseInfoByProductDocument, { id: entity.id })
          .mapSingle(({ product }) => product)
      )
    );
  }
}